import React from 'react';
import ImageViewer from '../../Component/ImageViewer';
import { MdClose } from 'react-icons/md';
import './imageModal.css';

function ImageModal({ imageUrl, backImg, onClose }) {
    // Close modal when clicking on overlay
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="image-modal-overlay" onClick={handleOverlayClick}>
            <div className="image-modal-content">
                <button className="image-modal-close" onClick={onClose}>
                    <MdClose size={24} />
                </button>
                <div className="image-modal-body">
                    <ImageViewer imageUrl={imageUrl} backImg={backImg} />
                </div>
            </div>
        </div>
    );
}

export default ImageModal;